// Friendlier Thai texts for field-level validation errors returned by the API.
import { ApiError } from '../api/client.ts';

const FIELD_TEXT: Record<string, string> = {
  name: 'ชื่อ 2–50 ตัวอักษร',
  fullName: 'ชื่อ 2–50 ตัวอักษร',
  phone: 'เบอร์มือถือ 10 หลัก เช่น 0812345678',
  consent: 'กรุณายอมรับนโยบายความเป็นส่วนตัว',
  note: 'หมายเหตุยาวเกิน 200 ตัวอักษร',
  reason: 'กรุณาระบุเหตุผล (ไม่เกิน 200 ตัวอักษร)',
  mapUrl: 'ลิงก์แผนที่ต้องขึ้นต้นด้วย https://',
  staffNote: 'โน้ตยาวเกิน 500 ตัวอักษร',
};

/** Field name → message for a VALIDATION ApiError; empty object for other errors. */
export function fieldErrors(e: unknown): Record<string, string> {
  if (e instanceof ApiError && e.code === 'VALIDATION' && e.field) {
    return { [e.field]: FIELD_TEXT[e.field] ?? e.message };
  }
  return {};
}

export function message(e: unknown): string {
  return e instanceof ApiError ? e.message : 'ระบบขัดข้อง กรุณาลองใหม่';
}
